import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../../common/Layout';
import { getElicos } from '../../services/services';
import { axiosClient, axiosClientEvent } from '../../api/axiosClient';
import Swal from 'sweetalert2';
import Select from 'react-select'
import { isEventFull } from '../../utils/eventStatus';

const goals = [
    'Ambil strategi tes yang tepat',
    'Ketahui apa yang penguji harapkan',
    'Dapatkan rencana belajar dari NIEC',
];

const CITY_TIMEZONE_MAP = {
    medan: 'WIB',
    jakarta: 'WIB',
    tangerang: 'WIB',
    bandung: 'WIB',
    yogyakarta: 'WIB',
    surabaya: 'WIB',
    makassar: 'WITA',
    denpasar: 'WITA',
};

const EventPage = () => {
    const [submitted, setSubmitted] = useState(false);
    const [elicosEvent, setElicosEvent] = useState([]);
    const [loadingEvent, setLoadingEvent] = useState(true);
    const [errorEvent, setErrorEvent] = useState(null);
    const [selectedEventId, setSelectedEventId] = useState(null);
    const [leadSource, setLeadSource] = useState([]);
    const [city, setCity] = useState([]);
    const [provinsi, setProvinsi] = useState([]);
    const [jenjang, setJenjang] = useState([]);
    const [sekolah, setSekolah] = useState([]);
    const [nama, setNama] = useState('');
    const [email, setEmail] = useState('');
    const [noWa, setNoWa] = useState('');
    const [kodekabkota, setKodekabkota] = useState(0);
    const [idProvinsi, setIdProvinsi] = useState('');
    const [codeJenjang, setCodeJenjang] = useState('');
    const [file, setFile] = useState('');
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [schoolNameManual, setSchoolNameManual] = useState('');
    const [kodeLeadsource, setKodeLeadsource] = useState('');
    const [isAlumni, setIsAlumni] = useState(false);
    const [btnDisable, setBtnDisable] = useState(false);
    const [isMember, setIsMember] = useState(false);
    const [imgLoaded, setImgLoaded] = useState(false);
    const [arrayNotes, setArrayNotes] = useState([
        { "kode_leadsource": "" },
        { "tahun_angkatan": "" },
        { "alamat": "" },
        { "keterangan": "" }
    ]);
    const [formErrors, setFormErrors] = useState({});

    const getLeadsSource = () => {
        axiosClient.get('master/lead-source')
            .then(res => res.data)
            .then(data => setLeadSource(data.data));
    };

    const getProvinsi = () => {
        axiosClient.get('master/provinces')
            .then(res => res.data)
            .then(data => setProvinsi(data.data));
    };

    const getJenjang = () => {
        axiosClient.get('master/jenjang')
            .then(res => res.data)
            .then(data => setJenjang(data.data));
    };

    const getSekolah = () => {
        if (!idProvinsi || idProvinsi === "0" || !codeJenjang || codeJenjang === "0") {
            setSekolah([]);
            setSelectedSchool(null);
            return;
        }

        axiosClient.get(`sekolah-indonesia?province_id=${idProvinsi}&jenjang=${codeJenjang}`)
            .then(res => res.data)
            .then(data => {
                const formattedOptions = data.data.map(item => ({
                    value: item.kode_sekolah,
                    label: item.nama_sekolah
                }));
                setSekolah(formattedOptions);
            });
    };

    // const getDefaultCodeLeadsSource = () => {
    //     const searchParams = new URLSearchParams(location.search);
    //     const source = searchParams.get('source');
    //     if (source === 'LS013') {
    //         setKodeLeadsource(source);
    //     }
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "nama") setNama(value);
        if (name === "email") setEmail(value);
        if (name === "kodekabkota") setKodekabkota(value);
        if (name === "kode_leadsource") {
            if (value === 'alumni') {
                setIsAlumni(true);
                setKodeLeadsource(value);
                updateNotesArray(setArrayNotes, name, value);
            } else {
                setIsAlumni(false);
                setKodeLeadsource(value);
            }
        }
        if (name === "id_provinsi") setIdProvinsi(value);
        if (name === "code_jenjang") setCodeJenjang(value);
        if (name === "tahun_angkatan") updateNotesArray(setArrayNotes, name, value);
        if (name === "alamat") updateNotesArray(setArrayNotes, name, value);
        if (name === "keterangan") {
            setSchoolNameManual(value);
            updateNotesArray(setArrayNotes, name, value);
        }

        // Clear related error on change
        setFormErrors(prev => ({ ...prev, [name]: undefined }));
    };

    const updateNotesArray = (setArrayNotes, name, value) => {
        setArrayNotes((prev) => {
            const exist = prev.findIndex((item) => item[name] !== undefined);

            if (exist !== -1) {
                const updated = [...prev];
                updated[exist] = { ...updated[exist], [name]: value }; // ⬅ merge, bukan replace
                return updated;
            }

            return [...prev, { [name]: value }];
        });
    };

    const handleChangeSekolah = (e) => {
        const { name, value } = e.target;

        if (name === "id_provinsi") {
            setIdProvinsi(value);
            setSelectedSchool(null);
        }
        if (name === "code_jenjang") {
            setCodeJenjang(value);
            setSelectedSchool(null);
        }

        setFormErrors(prev => ({ ...prev, [name]: undefined }));
    };

    const handleChangeEmail = (e) => {
        const value = e.target.value;
        setEmail(value);
        axiosClient.get('members/check-member/' + value)
            .then(res => {
                if (res.data.data != null) {
                    setIsMember(true);
                } else {
                    setIsMember(false);
                }
            });
        setFormErrors(prev => ({ ...prev, email: undefined }));
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setFormErrors(prev => ({ ...prev, file: undefined }));
    }

    const handleSelectSekolah = (val) => {
        setSelectedSchool(val);
    };

    // ---- FORM VALIDATION LOGIC ----
    function validateForm() {
        let errors = {};
        // For event with offline/hybrid, city required
        // if (
        //     (detailEvent.category_event === 'Offline' || detailEvent.category_event === 'Hybrid') &&
        //     city.length > 1 &&
        //     (!kodekabkota || kodekabkota === "0" || kodekabkota === 0)
        // ) {
        //     errors.kodekabkota = "Kota wajib diisi";
        // }

        // Is Alumni
        if (isAlumni) {
            // Validate tahun angkatan exists and not "0"
            const tahunAngkatanObj = arrayNotes.find(item => item.tahun_angkatan !== undefined);
            if (!tahunAngkatanObj || !tahunAngkatanObj.tahun_angkatan || tahunAngkatanObj.tahun_angkatan === "0") {
                errors.tahun_angkatan = "Tahun Angkatan wajib diisi";
            }
        }

        // Nama
        if (!nama || nama.trim() === "") {
            errors.nama = "Nama Lengkap wajib diisi";
        }

        // No WhatsApp (basic: exist and valid format)
        if (!noWa || noWa.trim() === "") {
            errors.no_wa = "No. WhatsApp wajib diisi";
        } else if (!/^\+?\d{7,20}$/.test(noWa)) {
            errors.no_wa = "No. WhatsApp tidak valid";
        }

        // Email
        if (!email || email.trim() === "") {
            errors.email = "Email wajib diisi";
        } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
            errors.email = "Email tidak valid";
        }

        // File pendukung (optional, only if required by event)
        // if (detailEvent.status_file === 1 && !file) {
        //     errors.file = "File pendukung wajib diunggah";
        // }

        // Provinsi
        if (!idProvinsi || idProvinsi === "0") {
            errors.id_provinsi = "Provinsi wajib diisi";
        }

        // Jenjang
        if (!codeJenjang || codeJenjang === "0") {
            errors.code_jenjang = "Jenjang Pendidikan wajib diisi";
        }

        // Sumber Informasi
        if (kodeLeadsource !== 'LS013' && (!kodeLeadsource || kodeLeadsource === "0")) {
            errors.kode_leadsource = "Sumber Informasi wajib diisi";
        }

        // Alamat (for certain event)
        // if (detailEvent.id === 386) {
        //     const alamatObj = arrayNotes.find(item => item.alamat !== undefined);
        //     if (!alamatObj || !alamatObj.alamat || alamatObj.alamat.trim() === "") {
        //         errors.alamat = "Alamat Lengkap wajib diisi";
        //     }
        // }
        return errors;
    }

    const sendRow = () => {
        if (!selectedEvent || isEventFull(selectedEvent)) {
            Swal.fire({
                title: 'Pendaftaran Penuh',
                icon: 'info',
                confirmButtonColor: '#c00019',
                text: 'Kuota event ini sudah penuh. Silakan pilih event berikutnya yang masih tersedia.',
            });
            return;
        }

        // --- FORM VALIDATION ---
        const errors = validateForm();
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            // Scroll to first error if exists
            const field = Object.keys(errors)[0];
            const el = document.getElementsByName(field)[0];
            if (el && el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "center" });

            // Show error swal
            Swal.fire({
                title: 'Gagal',
                icon: 'error',
                confirmButtonColor: '#c00019',
                text: errors[field] || 'Harap lengkapi form yang wajib diisi.',
            });
            setBtnDisable(false);
            return;
        }

        setBtnDisable(true);
        let formData = new FormData();
        formData.append('id_konten', selectedEvent.id);
        formData.append('id_kabkota', kodekabkota);
        formData.append('code_leads', kodeLeadsource);
        if (isMember) {
            formData.append('member', true);
        }
        formData.append('name', nama);
        formData.append('email', email);
        formData.append('phone', noWa.replace('+', ''));
        formData.append('sekolah', selectedSchool?.value || '');
        formData.append('province_id', idProvinsi);
        formData.append('code_jenjang', codeJenjang);
        formData.append('file', file);
        formData.append('keterangan', JSON.stringify(arrayNotes));

        axiosClientEvent.post('event/register', formData)
            .then(() => {
                setBtnDisable(false);
                setNama('');
                setEmail('');
                setNoWa('');
                Swal.fire({
                    title: 'Sukses',
                    icon: 'success',
                    confirmButtonColor: '#3085d6',
                    text: `Selamat kamu sudah berhasil terdaftar di event ${selectedEvent.name}, cek chat whatsapp kamu untuk info selanjutnya`,
                });
            })
            .catch(error => {
                console.log(error);
                setBtnDisable(false);
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    text: 'Terjadi kesalahan, cek kembali input anda',
                });
            });
    }

    useEffect(() => {
        getLeadsSource();
        getProvinsi();
        getJenjang();
        getSekolah();
        // getDefaultCodeLeadsSource();
    }, [idProvinsi, codeJenjang]);

    const getElicosEvent = async () => {
        setLoadingEvent(true);
        setErrorEvent(null);

        try {
            const response = await getElicos();
            setElicosEvent(response || []);
        } catch (error) {
            console.error(error);
            setErrorEvent("Gagal memuat event. Silakan coba lagi.");
        } finally {
            setLoadingEvent(false);
        }
    };

    useEffect(() => {
        getElicosEvent();
    }, []);

    // useEffect(() => {
    //     if (elicosEvent.length && !selectedEventId) {
    //         setSelectedEventId(elicosEvent[0].id);
    //     }
    // }, [elicosEvent]);

    const getTimezoneFromEvent = (eventItem) => {
        const area =
            eventItem.event_lokasi?.[0]?.kabupaten?.nama_kabkota ||
            eventItem.area ||
            '';

        const key = area.toLowerCase();

        for (const city in CITY_TIMEZONE_MAP) {
            if (key.includes(city)) {
                return CITY_TIMEZONE_MAP[city];
            }
        }

        // default Indonesia
        return 'WIB';
    };

    const normalizeText = (html) => {
        return html
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;/gi, ' ')
            .replace(/\u00A0/g, ' ')
            .replace(/\u2013|\u2014/g, '-')
            .replace(/\s+/g, ' ')
            .trim();
    };

    const formatDateTime = (date, timeZone = 'Asia/Jakarta') => {
        if (!date) return '-';

        return new Date(date).toLocaleDateString('id-ID', {
            timeZone: 'Asia/Jakarta',
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        });
    };

    const formatEventDateTime = (timeEvent, timezone = 'WIB') => {
        if (!timeEvent) {
            return { dateText: '-', timeText: '-' };
        }

        const date = new Date(typeof timeEvent === 'string' ? timeEvent.replace(' ', 'T') : timeEvent);

        if (isNaN(date.getTime())) {
            return { dateText: '-', timeText: '-' };
        }

        const dateText = date.toLocaleDateString('id-ID', {
            timeZone: 'Asia/Jakarta',
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        });

        const start = date.getHours();
        const end = start + 3;

        const timeText = `${String(start).padStart(2, '0')}.00 - ${String(end).padStart(2, '0')}.00 ${timezone}`;

        return { dateText, timeText };
    };

    const getEventDateTime = (eventItem) => {
        if (!eventItem) {
            return { dateText: '-', timeText: '-' };
        }

        const timezone = getTimezoneFromEvent(eventItem);
        const category = eventItem.category_event?.toLowerCase();

        if (category === 'offline') {
            return formatEventDateTime(
                eventItem.event_lokasi?.[0]?.time_event || eventItem.start_date,
                timezone
            );
        }

        return formatEventDateTime(
            eventItem.start_date || eventItem.event_lokasi?.[0]?.time_event,
            timezone
        );
    };


    const featuredEvent = useMemo(() => {
        if (!elicosEvent || elicosEvent.length === 0) return null;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Highlight hanya menampilkan event mendatang yang masih menerima pendaftaran.
        const upcomingEvents = elicosEvent.filter(event => {
            const eventDate = new Date(event.start_date);
            eventDate.setHours(0, 0, 0, 0);
            return eventDate >= today && !isEventFull(event);
        });

        if (upcomingEvents.length === 0) return null;

        // Urutkan berdasarkan tanggal terdekat
        upcomingEvents.sort(
            (a, b) => new Date(a.start_date) - new Date(b.start_date)
        );

        return upcomingEvents[0];
    }, [elicosEvent]);

    const { dateText, timeText } = featuredEvent
        ? getEventDateTime(featuredEvent)
        : { dateText: '-', timeText: '-' };

    const selectedEvent = useMemo(() => {
        if (!elicosEvent.length) return null;

        return (
            elicosEvent.find((event) => event.id === selectedEventId) ||
            elicosEvent[0]
        );
    }, [elicosEvent, selectedEventId]);

    const selectedEventIsFull = isEventFull(selectedEvent);
    const registerButtonDisabled = btnDisable || !selectedEvent || selectedEventIsFull;

    const toggleEvent = (id) => {
        setSelectedEventId(prev => {
            const next = prev === id ? null : id;

            // On mobile: auto-scroll to the registration panel when an event is selected
            if (next !== null && window.innerWidth < 992) {
                setTimeout(() => {
                    const panel = document.getElementById('event-register');
                    if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 120);
            }

            return next;
        });
    };

    return (
        <div className="event-page">
            <Layout>
                <section className="event-hero">
                    <div className="container">
                        <div className="row align-items-center gy-4">
                            <div className="col-lg-7 event-hero-copy">
                                <span className="event-eyebrow">NIEC English Course Events</span>
                                <h1>Siapkan next step kamu dengan sesi Bahasa Inggris yang lebih fokus.</h1>
                                <p>
                                    Ikuti berbagai info session dan kelas praktik terbaru yang dirancang khusus untuk mempersiapkan IELTS, studi ke luar negeri, dan English akademik kamu.
                                </p>
                                <div className="event-hero-actions">
                                    <a href="#event-register" className="btn btn-main btn-radius">
                                        Daftar Sekarang
                                    </a>
                                    <a href="#event-list" className="event-text-link">
                                        Jadwal Event <i className="far fa-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                {featuredEvent && (
                                    <div className="event-hero-card">
                                        <div className="event-card-pulse">
                                            <i className="far fa-bell"></i>
                                        </div>

                                        <span className="event-hero-card-label">
                                            Session Pilihan
                                        </span>

                                        <h2>{featuredEvent.name}</h2>

                                        <ul>
                                            <li>
                                                <i className="far fa-calendar-alt"></i>
                                                {dateText}
                                            </li>

                                            <li>
                                                <i className="far fa-clock"></i>
                                                {timeText}
                                            </li>

                                            <li>
                                                <i className="far fa-map-marker-alt"></i>
                                                {featuredEvent.event_lokasi?.[0]?.nama_lokasi ?? 'Online'}
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="event-content section-padding" id="event-list">
                    <div className="container">
                        <div className="row gy-5">
                            <div className="col-xl-8 col-lg-7">
                                <div className="event-section-heading event-reveal">
                                    <span>Event Terbaru</span>
                                    <h2>Pilih event yang sesuai dengan tujuan mu.</h2>
                                </div>

                                <div className="event-card-list">
                                    {loadingEvent && (
                                        <>
                                            {Array.from({ length: 4 }).map((_, i) => (
                                                <div className="event-card skeleton" key={i}>
                                                    <div className="event-card-image skeleton-box" />
                                                    <div className="event-card-body">
                                                        <div className="skeleton-line w-60" />
                                                        <div className="skeleton-line w-80" />
                                                        <div className="skeleton-line w-40" />
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    )}

                                    {!loadingEvent && errorEvent && (
                                        <div className="event-error">
                                            <p>{errorEvent}</p>
                                            <button onClick={getElicosEvent}>Coba lagi</button>
                                        </div>
                                    )}

                                    {!loadingEvent &&
                                        !errorEvent &&
                                        elicosEvent.map((eventItem, index) => {
                                            const { dateText, timeText } = getEventDateTime(eventItem);
                                            const eventIsFull = isEventFull(eventItem);
                                            const isActive = !eventIsFull && selectedEventId === eventItem.id;

                                            return (
                                                <button
                                                    type="button"
                                                    className={`event-card ${isActive ? 'active' : ''} ${eventIsFull ? 'full' : ''}`}
                                                    key={eventItem.id}
                                                    style={{ animationDelay: `${index * 110}ms` }}
                                                    disabled={eventIsFull}
                                                    aria-label={eventIsFull ? `${eventItem.name} - pendaftaran penuh` : undefined}
                                                    onClick={() => {
                                                        toggleEvent(eventItem.id);
                                                        setSubmitted(false);
                                                    }}
                                                >
                                                    <div className="event-card-image">
                                                        <img src={eventItem.image} alt={eventItem.name} />
                                                    </div>

                                                    <div className="event-card-body">
                                                        <div className="event-card-topline">
                                                            <span>IELTS Workshop</span>
                                                            <strong className={eventIsFull ? 'event-full-label' : ''}>
                                                                {eventIsFull ? 'Pendaftaran penuh' : 'Pendaftaran terbatas'}
                                                            </strong>
                                                        </div>

                                                        <h3>{eventItem.name}</h3>

                                                        <div className="event-meta-grid">
                                                            <span>
                                                                <i className="far fa-calendar-alt"></i> {dateText}
                                                            </span>
                                                            <span>
                                                                <i className="far fa-clock"></i> {timeText}
                                                            </span>
                                                            <span>
                                                                <i className="far fa-map-marker-alt"></i>{" "}
                                                                {eventItem.category_event === 'Offline' ? eventItem.event_lokasi?.[0]?.alamat : 'Online'}
                                                            </span>
                                                        </div>

                                                        {eventIsFull ? (
                                                            <div className="event-full-notice" role="status">
                                                                <i className="far fa-calendar-times" aria-hidden="true"></i>
                                                                <span>
                                                                    Kuota event ini sudah penuh. Kamu masih bisa mendaftar di event berikutnya.
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div className="detail-event-badge">
                                                                <span>
                                                                    <i className={`me-2 fa fa-chevron-${isActive ? 'up' : 'down'}`} />
                                                                    {isActive ? 'Tutup Detail' : 'Lihat Detail'}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Always in DOM — CSS fade controls visibility */}
                                                    <div className="event-card-detail">
                                                        {eventItem.description && (
                                                            <div
                                                                className="event-description"
                                                                dangerouslySetInnerHTML={{ __html: eventItem.description }}
                                                            />
                                                        )}
                                                    </div>

                                                </button>
                                            );
                                        })}
                                </div>
                            </div>

                            <div className="col-xl-4 col-lg-5">
                                <aside className="event-register-panel" id="event-register">
                                    <div className="event-selected">
                                        <span>Register for</span>
                                        <h3>{selectedEvent?.name}</h3>
                                        <p>
                                            {formatDateTime(selectedEvent?.start_date)}
                                        </p>
                                    </div>

                                    {selectedEventIsFull && (
                                        <div className="event-full-panel-alert" role="status">
                                            <i className="far fa-calendar-times" aria-hidden="true"></i>
                                            <div>
                                                <strong>Pendaftaran event ini sudah penuh</strong>
                                                <p>Pilih event berikutnya yang masih tersedia untuk melanjutkan pendaftaran.</p>
                                            </div>
                                        </div>
                                    )}

                                    <form autoComplete="off" style={{ padding: '10px 18px 20px 18px' }}>
                                        {/* {(detailEvent.category_event === 'Offline' || detailEvent.category_event === 'Hybrid') && city.length > 1 && (
                                            <div className='form-group mb-4'>
                                                <label style={{ fontWeight: 500, marginBottom: 5 }}>Kota <span style={{ color: '#c00019' }}>*</span></label>
                                                <select
                                                    className="form-control custom-dropdown"
                                                    name="kodekabkota"
                                                    onChange={handleChange}
                                                    value={kodekabkota}
                                                    style={formErrors.kodekabkota ? { borderColor: '#c00019' } : {}}
                                                >
                                                    <option value='0' defaultValue>-- Pilih Kota --</option>
                                                    {city.length > 0 &&
                                                        city.map((kota) => (
                                                            <option key={kota.id} value={kota.kode_kabkota}>{kota.kabupaten.nama_kabkota}</option>
                                                        ))
                                                    }
                                                </select>
                                                {formErrors.kodekabkota && <small style={{ color: '#c00019' }}>{formErrors.kodekabkota}</small>}
                                            </div>
                                        )} */}
                                        <div className='form-group mb-4'>
                                            <label style={{ fontWeight: 500, marginBottom: 5 }}>Nama Lengkap <span style={{ color: '#c00019' }}>*</span></label>
                                            <input
                                                type='text'
                                                placeholder="Nama Lengkap"
                                                className='form-control'
                                                name="nama"
                                                onChange={handleChange}
                                                value={nama}
                                                autoFocus
                                                required
                                                style={formErrors.nama ? { borderColor: '#c00019' } : {}}
                                            />
                                            {formErrors.nama && <small style={{ color: '#c00019' }}>{formErrors.nama}</small>}
                                        </div>
                                        <div className='form-group mb-4'>
                                            <label htmlFor="no_wa" style={{ fontWeight: 500, marginBottom: 5, display: 'block' }}>
                                                No. WhatsApp <span style={{ color: '#c00019' }}>*</span>
                                            </label>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="number"
                                                    placeholder='6281234567890'
                                                    className='form-control'
                                                    name='no_wa'
                                                    value={noWa}
                                                    onChange={(e) => {
                                                        setNoWa(e.target.value);
                                                        setFormErrors(prev => ({ ...prev, no_wa: undefined }));
                                                    }}
                                                    required
                                                />
                                                {/* <PhoneInput
                                                    id="no_wa"
                                                    defaultCountry='ID'
                                                    international
                                                    countryCallingCodeEditable={false}
                                                    placeholder="Nomor WhatsApp aktif"
                                                    value={noWa}
                                                    name="no_wa"
                                                    onChange={(value) => { setNoWa(value); setFormErrors(prev => ({ ...prev, no_wa: undefined })); }}
                                                    inputComponent="input"
                                                    style={{
                                                        width: '100%',
                                                        borderRadius: 5,
                                                        border: formErrors.no_wa ? '1px solid #c00019' : '1px solid #ced4da',
                                                        fontSize: 16,
                                                        padding: '8px 12px',
                                                        backgroundColor: '#fff',
                                                    }}
                                                /> */}
                                            </div>
                                            <small style={{ color: '#888', marginTop: 5, display: 'block' }}>
                                                Pastikan nomor WhatsApp aktif dan menggunakan format internasional (+62)
                                            </small>
                                            {formErrors.no_wa && <small style={{ color: '#c00019' }}>{formErrors.no_wa}</small>}
                                        </div>
                                        <div className='form-group mb-4'>
                                            <label style={{ fontWeight: 500, marginBottom: 5 }}>Email <span style={{ color: '#c00019' }}>*</span></label>
                                            <input
                                                placeholder="Email"
                                                className='form-control'
                                                name="email"
                                                onChange={handleChangeEmail}
                                                value={email}
                                                type="email"
                                                autoComplete="email"
                                                required
                                                style={formErrors.email ? { borderColor: '#c00019' } : {}}
                                            />
                                            {formErrors.email && <small style={{ color: '#c00019' }}>{formErrors.email}</small>}
                                        </div>
                                        {/* {detailEvent.status_file === 1 && (
                                            <div className='form-group mb-4'>
                                                <label style={{ fontWeight: 500, marginBottom: 5 }}>File pendukung (CV, Surat, dll) </label>
                                                <input type='file' className='form-control' name="register_file" onChange={handleFileChange} style={formErrors.file ? { borderColor: '#c00019' } : {}} />
                                                {formErrors.file && <small style={{ color: '#c00019' }}>{formErrors.file}</small>}
                                            </div>
                                        )} */}
                                        <div className='form-group mb-4'>
                                            <label style={{ fontWeight: 500, marginBottom: 5 }}>Provinsi Tempat Tinggal<span style={{ color: '#c00019' }}>*</span></label>
                                            <select
                                                className="form-control custom-dropdown"
                                                name="id_provinsi"
                                                value={idProvinsi}
                                                onChange={handleChangeSekolah}
                                                style={formErrors.id_provinsi ? { borderColor: '#c00019' } : {}}
                                            >
                                                <option value='0' defaultValue>-- Pilih Provinsi --</option>
                                                {provinsi.length > 0 &&
                                                    provinsi.map((province) => (
                                                        <option key={province.id} value={province.id}>{province.province_name}</option>
                                                    ))
                                                }
                                            </select>
                                            {formErrors.id_provinsi && <small style={{ color: '#c00019' }}>{formErrors.id_provinsi}</small>}
                                        </div>
                                        <div className='form-group mb-4'>
                                            <label style={{ fontWeight: 500, marginBottom: 5 }}>Jenjang Pendidikan Terakhir <span style={{ color: '#c00019' }}>*</span></label>
                                            <select
                                                className="form-control custom-dropdown"
                                                name="code_jenjang"
                                                value={codeJenjang}
                                                onChange={handleChangeSekolah}
                                                style={formErrors.code_jenjang ? { borderColor: '#c00019' } : {}}
                                            >
                                                <option value='0' defaultValue>-- Pilih Jenjang --</option>
                                                {jenjang.length > 0 &&
                                                    jenjang.map((jenjang) => (
                                                        <option key={jenjang.code_jenjang} value={jenjang.code_jenjang}>{jenjang.jenjang_pendidikan}</option>
                                                    ))
                                                }
                                            </select>
                                            {formErrors.code_jenjang && <small style={{ color: '#c00019' }}>{formErrors.code_jenjang}</small>}
                                        </div>
                                        {/* {detailEvent.id === 386 && (
                                            <div className='form-group mb-4'>
                                                <label style={{ fontWeight: 500, marginBottom: 5 }}>Alamat Lengkap</label>
                                                <textarea
                                                    placeholder="Alamat"
                                                    className='form-control'
                                                    name="alamat"
                                                    onChange={handleChange}
                                                    rows={2}
                                                    style={formErrors.alamat ? { borderColor: '#c00019' } : {}}
                                                />
                                                {formErrors.alamat && <small style={{ color: '#c00019' }}>{formErrors.alamat}</small>}
                                            </div>
                                        )} */}
                                        {kodeLeadsource !== 'LS013' && (
                                            <div className='form-group mb-4'>
                                                <label style={{ fontWeight: 500, marginBottom: 5 }}>Tau darimana tentang event ini? <span style={{ color: '#c00019' }}>*</span></label>
                                                <select
                                                    className="form-control custom-dropdown"
                                                    name="kode_leadsource"
                                                    onChange={handleChange}
                                                    value={kodeLeadsource}
                                                    style={formErrors.kode_leadsource ? { borderColor: '#c00019' } : {}}
                                                >
                                                    <option value='0' defaultValue>-- Pilih Sumber Informasi --</option>
                                                    {leadSource != null &&
                                                        leadSource.map((lead) => (
                                                            <option key={lead.id_leads_source} value={lead.code_leads_source}>{lead.source}</option>
                                                        ))
                                                    }
                                                    <option value='alumni'>Alumni</option>
                                                </select>
                                                {formErrors.kode_leadsource && <small style={{ color: '#c00019' }}>{formErrors.kode_leadsource}</small>}
                                            </div>
                                        )}
                                        <div className="detail-optional-separator">
                                            <span>Opsional</span>
                                        </div>
                                        <div className='form-group mb-4'>
                                            <label style={{ fontWeight: 500, marginBottom: 5 }}>Sekolah Asal</label>
                                            <Select
                                                placeholder={
                                                    idProvinsi && idProvinsi !== "0" && codeJenjang && codeJenjang !== "0"
                                                        ? "Pilih Sekolah..."
                                                        : "Pilih provinsi dan jenjang dulu"
                                                }
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                isClearable={true}
                                                isDisabled={!idProvinsi || idProvinsi === "0" || !codeJenjang || codeJenjang === "0"}
                                                className="basic-single"
                                                onChange={handleSelectSekolah}
                                                value={selectedSchool}
                                                options={sekolah}
                                                noOptionsMessage={() => "Sekolah tidak ditemukan"}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: 38,
                                                        borderRadius: 5,
                                                    })
                                                }}
                                            />
                                            <small style={{ color: '#888', marginTop: 5, display: 'block' }}>
                                                Daftar sekolah dimuat berdasarkan Provinsi Tempat Tinggal dan Jenjang Pendidikan Terakhir.
                                            </small>
                                        </div>
                                        <div className='form-group mb-4'>
                                            <label style={{ fontWeight: 500, marginBottom: 5 }}>Input Nama Sekolah</label>
                                            <input
                                                type='text'
                                                placeholder="Tulis nama sekolah jika tidak ada di daftar"
                                                className='form-control'
                                                name="keterangan"
                                                onChange={handleChange}
                                                value={schoolNameManual}
                                            />
                                            <small style={{ color: '#888', marginTop: 5, display: 'block' }}>
                                                Isi bagian ini hanya jika sekolah asal tidak ditemukan pada pilihan di atas.
                                            </small>
                                        </div>

                                        {/* {isAlumni && (
                                <div className='form-group mb-4'>
                                    <label style={{ fontWeight: 500, marginBottom: 5 }}>Tahun Angkatan<span style={{color:'#c00019'}}>*</span></label>
                                    <select
                                        className="form-control custom-dropdown"
                                        name="tahun_angkatan"
                                        onChange={handleChange}
                                        style={formErrors.tahun_angkatan ? {borderColor:'#c00019'} : {}}
                                    >
                                        <option value='0' defaultValue>-- Pilih Tahun Angkatan --</option>
                                        {years.map((year) => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>
                                    {formErrors.tahun_angkatan && <small style={{ color:'#c00019'}}>{formErrors.tahun_angkatan}</small>}
                                </div>
                            )} */}
                                        <div className='d-flex justify-content-end'>
                                            <button
                                                disabled={registerButtonDisabled}
                                                className="btn-custom"
                                                type='button'
                                                onClick={sendRow}
                                                style={{
                                                    background: 'linear-gradient(90deg,#c00019 70%, #ff7675 100%)',
                                                    color: '#fff',
                                                    fontWeight: 600,
                                                    border: 'none',
                                                    borderRadius: '28px',
                                                    minWidth: 130,
                                                    padding: '10px 22px',
                                                    boxShadow: registerButtonDisabled
                                                        ? '0px 0px 0 #ccc'
                                                        : '0 3px 18px 0 rgba(192,0,25,0.12)',
                                                    transition: 'all .15s',
                                                    opacity: registerButtonDisabled ? 0.65 : 1,
                                                    cursor: registerButtonDisabled ? 'not-allowed' : 'pointer'
                                                }}
                                            >
                                                {selectedEventIsFull
                                                    ? <span>Pendaftaran Penuh</span>
                                                    : btnDisable
                                                    ? <span><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Registering...</span>
                                                    : <span>Daftar Sekarang</span>
                                                }
                                            </button>
                                        </div>
                                    </form>

                                    {submitted && (
                                        <p className="event-success-message">
                                            Registration received. Our team will contact you through WhatsApp.
                                        </p>
                                    )}
                                </aside>
                            </div>
                        </div>

                        <div className="event-benefit-strip">
                            {goals.map((goal, index) => (
                                <div className="event-benefit" key={goal} style={{ animationDelay: `${index * 120}ms` }}>
                                    <i className="far fa-check-circle"></i>
                                    <span>{goal}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </Layout>

            {/* ── Mobile sticky register bar ── only visible on small screens when an event is selected */}
            {selectedEvent && (
                <div className="mobile-register-bar" aria-live="polite">
                    <div className="mobile-register-bar-content">
                        <div className="mobile-register-bar-info">
                            <span className="mobile-register-bar-label">Selected event</span>
                            <strong className="mobile-register-bar-name">{selectedEvent.name}</strong>
                        </div>
                        <button
                            type="button"
                            className={`mobile-register-bar-btn ${selectedEventIsFull ? 'disabled' : ''}`}
                            disabled={selectedEventIsFull}
                            onClick={() => {
                                const panel = document.getElementById('event-register');
                                if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }}
                        >
                            {selectedEventIsFull ? 'Penuh' : 'Register'}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EventPage;
